import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var FillAndSignSvg = function FillAndSignSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.79 6.789 14.006 2 3 13.012V17.8h4.786zM4.493 16.307V13.63l9.513-9.518 2.676 2.677-9.513 9.518zM15.87 15.374a2.25 2.25 0 0 0-2.016 1.247l-.014.029a2.31 2.31 0 0 0 .431 2.66l.533.532a3 3 0 0 1-1.878.665h-9.88V22h9.88a4.47 4.47 0 0 0 2.944-1.105A4.48 4.48 0 0 0 18.816 22H21v-1.493h-2.185a3 3 0 0 1-1.878-.665l.533-.533a2.31 2.31 0 0 0 .431-2.66l-.016-.033a2.26 2.26 0 0 0-2.015-1.242m.545 2.88-.544.544-.545-.544a.81.81 0 0 1-.152-.937l.014-.028a.763.763 0 0 1 1.365 0l.016.03a.81.81 0 0 1-.154.934",
    clipRule: "evenodd"
  }));
};
export var FillAndSign = function FillAndSign(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: FillAndSignSvg
  }));
};